export default {
    isAuthenticated: state => !!state.access_token,
    authStatus: state => state.status,
    authErrors: state => state.errors,
    getAdmRoles: state => state.admRoles,
    pendingLoginData: state => state.pendingLoginData,
    refreshToken: state => state.refresh_token
}
